export default __webpack_public_path__ + "static/media/phone.0d461ee9.svg";